import { render } from "./ContentSaveIcon.vue?vue&type=template&id=2f12ae8e"
import script from "./ContentSaveIcon.vue?vue&type=script&lang=js"
export * from "./ContentSaveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__